export const confirmationDialogueData = {
  message:
    'Are you sure you want to permanently delete this property?<br><br>This action cannot be undone and all associated data will be lost.',
};
